import { render, staticRenderFns } from "./SolicitacoesAcessoMesDash.vue?vue&type=template&id=bfeee48a&"
import script from "./SolicitacoesAcessoMesDash.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesAcessoMesDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports